export type CancelServicesFormState = {
  selectedServiceIds: string[]
  cancelConfirmation: string
  notServicedReason: string
}

export const cancelServicesInitialValues: CancelServicesFormState = {
  selectedServiceIds: [],
  cancelConfirmation: '',
  notServicedReason: '',
}
